import Medusa from '@medusajs/medusa-js';

export const medusaClient = new Medusa({
    maxRetries: 3,
    baseUrl: '/',
});
